import {PublicClientApplication} from "@azure/msal-browser";
import {msalConfig} from "../authConfig";

const msalInstance = new PublicClientApplication(msalConfig);
async function fetchIdToken() {
  const activeAccount = msalInstance.getActiveAccount();
  try {
    const response = await msalInstance.acquireTokenSilent({
      account: activeAccount,
      scopes: ["openid", "profile"],
    });
    return response;
  } catch (error) {
    await msalInstance.logoutRedirect({
      logoutHint: activeAccount.idTokenClaims.login_hint,
    });
  }
}

export {fetchIdToken};
export default msalInstance;
